import { render, staticRenderFns } from "./laborCompliance.vue?vue&type=template&id=7c203f82&"
import script from "./laborCompliance.vue?vue&type=script&lang=js&"
export * from "./laborCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports